export type CoinGeckoIdToImageUrl = {
  [id: string]: string;
};

export const COIN_GECKO_IMAGE_URLS: CoinGeckoIdToImageUrl = {
  "0xmonero":
    "https://assets.coingecko.com/coins/images/11035/small/0xmnr.PNG?1587357680",
  "1inch":
    "https://assets.coingecko.com/coins/images/13469/small/1inch-token.png?1608803028",
  "1safu":
    "https://assets.coingecko.com/coins/images/22792/small/145941796-8f7716f4-66bc-4a38-9ad5-441525c3b5b2.png?1642581127",
  "1sol":
    "https://assets.coingecko.com/coins/images/21615/small/YyGDie9f_400x400.jpg?1639610633",
  "3x-long-ethereum-token":
    "https://assets.coingecko.com/coins/images/10163/small/683JEXMN_400x400_%281%29.png?1576504568",
  aave: "https://assets.coingecko.com/coins/images/12645/small/AAVE.png?1601374110",
  "aave-polygon-usdc":
    "https://assets.coingecko.com/coins/images/17249/small/amUSDC_2x.png?1626941306",
  "aave-weth":
    "https://assets.coingecko.com/coins/images/17238/small/aWETH_2x.png?1626940782",
  "abitshadow-token":
    "https://assets.coingecko.com/coins/images/7882/small/ABST.png?1644477172",
  "acy-finance":
    "https://assets.coingecko.com/coins/images/21883/small/ubfPhcEK_400x400.jpg?1640214613",
  adapad:
    "https://assets.coingecko.com/coins/images/18273/small/EhSqPTtG_400x400.jpg?1631181091",
  ageur:
    "https://assets.coingecko.com/coins/images/19479/small/agEUR.png?1635283566",
  "akita-inu":
    "https://assets.coingecko.com/coins/images/14115/small/logo_%282%29.png?1644913173",
  akropolis:
    "https://assets.coingecko.com/coins/images/3328/small/Akropolis.png?1547037929",
  alchemix:
    "https://assets.coingecko.com/coins/images/14113/small/Alchemix.png?1614409874",
  aldrin:
    "https://assets.coingecko.com/coins/images/16849/small/Aldrin.png?1629959768",
  aleph:
    "https://assets.coingecko.com/coins/images/11676/small/Monochram-aleph.png?1608483725",
  allbridge:
    "https://assets.coingecko.com/coins/images/18690/small/abr.png?1640742053",
  "amp-token":
    "https://assets.coingecko.com/coins/images/12409/small/amp-200x200.png?1599625397",
  ampleforth:
    "https://assets.coingecko.com/coins/images/4708/small/Ampleforth.png?1561684250",
  "amy-finance":
    "https://assets.coingecko.com/coins/images/18719/small/9oSy6bTl_400x400.png?1633127387",
  "anchor-beth-token":
    "https://assets.coingecko.com/coins/images/21002/small/bETH.png?1638187691",
  "anchor-protocol":
    "https://assets.coingecko.com/coins/images/14420/small/anchor_protocol_logo.jpg?1615965420",
  anchorust:
    "https://assets.coingecko.com/coins/images/21097/small/aust.png?1638324579",
  "angle-protocol":
    "https://assets.coingecko.com/coins/images/19060/small/ANGLE_Token_Logo.png?1635281291",
  apyswap:
    "https://assets.coingecko.com/coins/images/14163/small/apys.png?1635831990",
  ardcoin:
    "https://assets.coingecko.com/coins/images/9432/small/ARDC.png?1627466542",
  ariadne:
    "https://assets.coingecko.com/coins/images/19401/small/Frame_5_%287%29_%281%29.png?1635176608",
  artem:
    "https://assets.coingecko.com/coins/images/21998/small/ARTM_Logo_MAIN_%281%29.png?1644469331",
  arth: "https://assets.coingecko.com/coins/images/16876/small/ARTH_Token.png?1625651538",
  "atlas-dex":
    "https://assets.coingecko.com/coins/images/23002/small/logo.png?1643091340",
  auditchain:
    "https://assets.coingecko.com/coins/images/6398/small/auditchain.png?1547042519",
  audius:
    "https://assets.coingecko.com/coins/images/12913/small/AudiusCoinLogo_2x.png?1603425727",
  "augmented-finance":
    "https://assets.coingecko.com/coins/images/20077/small/200x200-agf.png?1636452467",
  augur:
    "https://assets.coingecko.com/coins/images/309/small/REP.png?1596339859",
  "aurora-dao":
    "https://assets.coingecko.com/coins/images/2565/small/logomark-purple-286x286.png?1638362736",
  aurory:
    "https://assets.coingecko.com/coins/images/19324/small/logo.png?1635076945",
  "avalanche-2":
    "https://assets.coingecko.com/coins/images/12559/small/coin-round-red.png?1604021818",
  "axie-infinity":
    "https://assets.coingecko.com/coins/images/13029/small/axie_infinity_logo.png?1604471082",
  "baby-doge-coin":
    "https://assets.coingecko.com/coins/images/16125/small/Baby_Doge.png?1623044048",
  babytigergold:
    "https://assets.coingecko.com/coins/images/22811/small/logo_babytiger.png?1642658264",
  "bamboo-coin":
    "https://assets.coingecko.com/coins/images/19620/small/FC0hnduacAAHYFC.png?1635496724",
  banana:
    "https://assets.coingecko.com/coins/images/17521/small/banana-token-cg.png?1646285527",
  banano:
    "https://assets.coingecko.com/coins/images/6226/small/banano-transparent.png?1619589798",
  bancor:
    "https://assets.coingecko.com/coins/images/736/small/bancor-bnt.png?1628822309",
  "basic-attention-token":
    "https://assets.coingecko.com/coins/images/677/small/basic-attention-token.png?1547034427",
  "battle-of-guardians-share":
    "https://assets.coingecko.com/coins/images/22285/small/K3hU77wS_400x400.jpg?1641365642",
  "beefy-finance":
    "https://assets.coingecko.com/coins/images/12704/small/token.png?1601876182",
  benqi:
    "https://assets.coingecko.com/coins/images/16362/small/GergDDN3_400x400.jpg?1644984441",
  "benqi-liquid-staked-avax":
    "https://assets.coingecko.com/coins/images/23657/small/savax_blue.png?1644989825",
  "biconomy-exchange-token":
    "https://assets.coingecko.com/coins/images/18198/small/mGky0OOh_400x400.jpg?1630965301",
  bilira:
    "https://assets.coingecko.com/coins/images/10119/small/JBs9jiXO_400x400.jpg?1642668342",
  "binance-bitcoin":
    "https://assets.coingecko.com/coins/images/14108/small/Binance-bitcoin.png?1617332330",
  "binance-eth":
    "https://assets.coingecko.com/coins/images/13804/small/Binnace.png?1611997829",
  "binance-usd":
    "https://assets.coingecko.com/coins/images/9576/small/BUSD.png?1568947766",
  "binance-wrapped-btc":
    "https://assets.coingecko.com/coins/images/14867/small/binance-btc_32.png?1618814666",
  binancecoin:
    "https://assets.coingecko.com/coins/images/825/small/bnb-icon2_2x.png?1644979850",
  "bird-money":
    "https://assets.coingecko.com/coins/images/13260/small/favicon-180x180.png?1611546646",
  biswap:
    "https://assets.coingecko.com/coins/images/16845/small/biswap.png?1625388985",
  bitcoin:
    "https://assets.coingecko.com/coins/images/1/small/bitcoin.png?1547033579",
  bitlocus:
    "https://assets.coingecko.com/coins/images/20913/small/btl.png?1637922710",
  bitsong:
    "https://assets.coingecko.com/coins/images/5041/small/logo_-_2021-01-10T210801.390.png?1610284134",
  bitspawn:
    "https://assets.coingecko.com/coins/images/16513/small/token_logo.png?1631603192",
  blockasset:
    "https://assets.coingecko.com/coins/images/21332/small/Blockasset-Logo-Symbol.png?1648442722",
  "blocto-token":
    "https://assets.coingecko.com/coins/images/18657/small/BLT_token.png?1633082645",
  bloktopia:
    "https://assets.coingecko.com/coins/images/18819/small/logo-bholdus-6.png?1633518105",
  bluzelle:
    "https://assets.coingecko.com/coins/images/2848/small/ColorIcon_3x.png?1622516510",
  "bonded-luna":
    "https://assets.coingecko.com/coins/images/22369/small/17013.png?1641766740",
  bonfida:
    "https://assets.coingecko.com/coins/images/13395/small/fida-dark.png?1608112224",
  boozedoge:
    "https://assets.coingecko.com/coins/images/18852/small/Booze-Logo-CMC.png?1633592459",
  botxcoin:
    "https://assets.coingecko.com/coins/images/6827/small/botx.jpg?1548317786",
  "bridge-mutual":
    "https://assets.coingecko.com/coins/images/13808/small/bmi_logo.png?1612009598",
  brz: "https://assets.coingecko.com/coins/images/8472/small/2_vtiD3xwce9knG2COxtSMaQ.png?1597786961",
  "bull-coin":
    "https://assets.coingecko.com/coins/images/15975/small/bull_ms.94cd70ff.png?1622525834",
  burp: "https://assets.coingecko.com/coins/images/17317/small/Big_Town_Chef_-__BURP_-_Avatar_3x.png?1646202255",
  "bxmi-token":
    "https://assets.coingecko.com/coins/images/20859/small/1QE9Pge.png?1637803118",
  cake: "https://assets.coingecko.com/coins/images/21639/small/cake.png?1639630973",
  cardano:
    "https://assets.coingecko.com/coins/images/975/small/cardano.png?1547034860",
  cartesi:
    "https://assets.coingecko.com/coins/images/11038/small/cartesi.png?1592288021",
  cashcow:
    "https://assets.coingecko.com/coins/images/19388/small/cash_cow.png?1648265503",
  catecoin:
    "https://assets.coingecko.com/coins/images/15364/small/logo.png?1620647627",
  catzcoin:
    "https://assets.coingecko.com/coins/images/15519/small/MX0hFr7.jpeg?1621118815",
  "celer-network":
    "https://assets.coingecko.com/coins/images/4379/small/Celr.png?1554705437",
  celo: "https://assets.coingecko.com/coins/images/11090/small/icon-celo-CELO-color-500.png?1592293590",
  "celsius-degree-token":
    "https://assets.coingecko.com/coins/images/3263/small/CEL_logo.png?1609598753",
  chain:
    "https://assets.coingecko.com/coins/images/19678/small/Chain_icon.png?1635741399",
  "chain-games":
    "https://assets.coingecko.com/coins/images/12257/small/chain-logo-centered-500x500.png?1599617244",
  chainlink:
    "https://assets.coingecko.com/coins/images/877/small/chainlink-new-logo.png?1547034700",
  charli3:
    "https://assets.coingecko.com/coins/images/15052/small/Charli3-Profile-Icon-1.png?1642643567",
  chi: "https://assets.coingecko.com/coins/images/20130/small/sIuRXww.png?1636528063",
  chiliz:
    "https://assets.coingecko.com/coins/images/8834/small/Chiliz.png?1561970540",
  chronobank:
    "https://assets.coingecko.com/coins/images/604/small/time-32x32.png?1627130666",
  chronologic:
    "https://assets.coingecko.com/coins/images/951/small/Chronologic-network.png?1547034815",
  cindicator:
    "https://assets.coingecko.com/coins/images/1006/small/cindicator.png?1547034913",
  civic:
    "https://assets.coingecko.com/coins/images/788/small/Civic-logo-blue.png?1636393120",
  "clintex-cti":
    "https://assets.coingecko.com/coins/images/13266/small/CTI.png?1606817542",
  "coin-capsule":
    "https://assets.coingecko.com/coins/images/15921/small/e55393fa-7b4d-40f5-9f36-9a8a6bdcb570.png?1622430581",
  "coin-discovery":
    "https://assets.coingecko.com/coins/images/18839/small/IdvWAhot_400x400.jpg?1633572605",
  coin98:
    "https://assets.coingecko.com/coins/images/17117/small/logo.png?1626412904",
  "compound-governance-token":
    "https://assets.coingecko.com/coins/images/10775/small/COMP.png?1592625425",
  constitutiondao:
    "https://assets.coingecko.com/coins/images/20612/small/GN_UVm3d_400x400.jpg?1637294355",
  contentos:
    "https://assets.coingecko.com/coins/images/8379/small/4036.png?1561085375",
  cosmos:
    "https://assets.coingecko.com/coins/images/1481/small/cosmos_hub.png?1555657960",
  covalent:
    "https://assets.coingecko.com/coins/images/14168/small/covalent-cqt.png?1624545218",
  "cream-2":
    "https://assets.coingecko.com/coins/images/11976/small/Cream.png?1596593418",
  credefi:
    "https://assets.coingecko.com/coins/images/21396/small/e1QbZ4qQ_400x400.jpg?1639042835",
  cropperfinance:
    "https://assets.coingecko.com/coins/images/17883/small/copperfinance.PNG?1629708744",
  "crowny-token":
    "https://assets.coingecko.com/coins/images/14958/small/crowny-icon-rounded_2x.png?1619147225",
  "crypto-fight-club":
    "https://assets.coingecko.com/coins/images/21695/small/zGwwAgL.png?1639721544",
  curate:
    "https://assets.coingecko.com/coins/images/13327/small/400x400_%281%29_%283%29_%282%29.png?1613998208",
  "curve-dao-token":
    "https://assets.coingecko.com/coins/images/12124/small/Curve.png?1597369484",
  dai: "https://assets.coingecko.com/coins/images/9956/small/4943.png?1636636734",
  "dao-maker":
    "https://assets.coingecko.com/coins/images/13915/small/4.png?1612838831",
  "data-economy-index":
    "https://assets.coingecko.com/coins/images/18500/small/data_32.png?1632209427",
  "dds-store":
    "https://assets.coingecko.com/coins/images/13946/small/11qbAbzb_400x400.png?1613172588",
  "dead-knight":
    "https://assets.coingecko.com/coins/images/24442/small/SAq1GaQc_400x400.jpg?1647673953",
  decentraland:
    "https://assets.coingecko.com/coins/images/878/small/decentraland-mana.png?1550108745",
  defiato:
    "https://assets.coingecko.com/coins/images/13386/small/Defiato.png?1608085873",
  defil:
    "https://assets.coingecko.com/coins/images/17708/small/defillogo200200.png?1629080381",
  defire:
    "https://assets.coingecko.com/coins/images/15722/small/defire.PNG?1621635373",
  derace:
    "https://assets.coingecko.com/coins/images/17438/small/derace-logo-black-coingecko.png?1627656907",
  dexlab:
    "https://assets.coingecko.com/coins/images/17276/small/3_GradientSymbol.png?1650936792",
  dinox:
    "https://assets.coingecko.com/coins/images/17321/small/asset_icon_dnxc_200.png?1627292452",
  dogecoin:
    "https://assets.coingecko.com/coins/images/5/small/dogecoin.png?1547792256",
  "dogelon-mars":
    "https://assets.coingecko.com/coins/images/14962/small/6GxcPRo3_400x400.jpg?1619157413",
  "dogemon-go":
    "https://assets.coingecko.com/coins/images/17480/small/dogemongo.PNG?1627950869",
  "dragons-quick":
    "https://assets.coingecko.com/coins/images/15185/small/quickswap.png?1620044811",
  dragonsb:
    "https://assets.coingecko.com/coins/images/23738/small/Bo9_OxOV_400x400.jpg?1645176823",
  dydx: "https://assets.coingecko.com/coins/images/17500/small/hjnIm9bV.jpg?1628009360",
  "eagonswap-token":
    "https://assets.coingecko.com/coins/images/20431/small/IMG-20210912-WA0003.jpg?1637035180",
  easyfi:
    "https://assets.coingecko.com/coins/images/12742/small/Logo_Icon.png?1624471467",
  echoin:
    "https://assets.coingecko.com/coins/images/9354/small/L32_KzNQ_400x400.jpg?1566513096",
  ecomi:
    "https://assets.coingecko.com/coins/images/4428/small/ECOMI.png?1557928886",
  "elite-swap":
    "https://assets.coingecko.com/coins/images/13715/small/logo_-_2021-01-20T105016.992.png?1611111027",
  elyfi:
    "https://assets.coingecko.com/coins/images/23733/small/elyfi_logo.png?1645691480",
  enjincoin:
    "https://assets.coingecko.com/coins/images/1102/small/enjin-coin-logo.png?1547035078",
  erc20:
    "https://assets.coingecko.com/coins/images/1141/small/0c213e0a1ee44bd8a3c952ffc5bc5a45.png?1628771346",
  ertha:
    "https://assets.coingecko.com/coins/images/20317/small/Ry9tgUal_400x400.jpg?1636856709",
  esg: "https://assets.coingecko.com/coins/images/24932/small/esg.png?1649397514",
  essentia:
    "https://assets.coingecko.com/coins/images/2483/small/Essentia-token.jpg?1547036604",
  ethereum:
    "https://assets.coingecko.com/coins/images/279/small/ethereum.png?1595348880",
  "ethereum-meta":
    "https://assets.coingecko.com/coins/images/6586/small/ethereum-meta.png?1548125409",
  "ethereum-name-service":
    "https://assets.coingecko.com/coins/images/19785/small/acatxTm8_400x400.jpg?1635850140",
  "ethernity-chain":
    "https://assets.coingecko.com/coins/images/14238/small/LOGO_HIGH_QUALITY.png?1647831402",
  everid:
    "https://assets.coingecko.com/coins/images/5209/small/Everest.jpg?1628042930",
  evrynet:
    "https://assets.coingecko.com/coins/images/19194/small/evry.png?1634637970",
  fantom:
    "https://assets.coingecko.com/coins/images/4001/small/Fantom.png?1558015016",
  "feisty-doge-nft":
    "https://assets.coingecko.com/coins/images/17834/small/doge-fractionalized.png?1629390495",
  "flag-network":
    "https://assets.coingecko.com/coins/images/22552/small/17215.png?1642053401",
  "floki-inu":
    "https://assets.coingecko.com/coins/images/16746/small/PNG_image.png?1643184642",
  floof:
    "https://assets.coingecko.com/coins/images/19810/small/FLOOF_logo_200x200.png?1635917291",
  "foxy-equilibrium":
    "https://assets.coingecko.com/coins/images/17303/small/cmc200x200.png?1627268759",
  frax: "https://assets.coingecko.com/coins/images/13422/small/frax_logo.png?1608476506",
  "frax-share":
    "https://assets.coingecko.com/coins/images/13423/small/frax_share.png?1608478989",
  "free-novak":
    "https://assets.coingecko.com/coins/images/23370/small/logo_%282%29.png?1643955421",
  "frontier-token":
    "https://assets.coingecko.com/coins/images/12479/small/frontier_logo.png?1600145472",
  "ftx-token":
    "https://assets.coingecko.com/coins/images/9026/small/F.png?1609051564",
  "gaia-everworld":
    "https://assets.coingecko.com/coins/images/19629/small/gaia.png?1646481791",
  gaj: "https://assets.coingecko.com/coins/images/15257/small/logo200x200.png?1629887093",
  gala: "https://assets.coingecko.com/coins/images/12493/small/GALA-COINGECKO.png?1600233435",
  "galaxy-war":
    "https://assets.coingecko.com/coins/images/22166/small/e2x7gMJ4_400x400.jpg?1641166277",
  "gari-network":
    "https://assets.coingecko.com/coins/images/22615/small/gari.png?1642313087",
  gemguardian:
    "https://assets.coingecko.com/coins/images/18614/small/gemg.PNG?1632697389",
  "gemma-extending-tech":
    "https://assets.coingecko.com/coins/images/12226/small/200.png?1643188059",
  "genaro-network":
    "https://assets.coingecko.com/coins/images/1361/small/genaro-network.png?1547035387",
  gene: "https://assets.coingecko.com/coins/images/14145/small/logo.a60a0c80_%281%29.png?1614653629",
  genopets:
    "https://assets.coingecko.com/coins/images/20360/small/gene-token.png?1636945172",
  "gera-coin":
    "https://assets.coingecko.com/coins/images/13686/small/GeraCoin_Logo-icon-1000px.png?1610919942",
  "globaltrustfund-token":
    "https://assets.coingecko.com/coins/images/11817/small/gtf.png?1594679456",
  "gmt-token":
    "https://assets.coingecko.com/coins/images/15662/small/gmt.png?1640069038",
  goosefx:
    "https://assets.coingecko.com/coins/images/19793/small/0Kjm9f4.png?1635906737",
  "governance-ohm":
    "https://assets.coingecko.com/coins/images/21129/small/token_wsOHM_logo.png?1638764900",
  "grape-2":
    "https://assets.coingecko.com/coins/images/18149/small/fRsuAlcV_400x400.png?1632437325",
  graviton:
    "https://assets.coingecko.com/coins/images/24818/small/Graviton_-_Blue_200x200i.png?1649038479",
  "green-satoshi-token":
    "https://assets.coingecko.com/coins/images/21841/small/gst.png?1640332626",
  "green-shiba-inu":
    "https://assets.coingecko.com/coins/images/15649/small/inu-logo-new-200x200.png?1625578449",
  "hanu-yokia":
    "https://assets.coingecko.com/coins/images/17161/small/Goji_Hanu_Logo_200x200.png?1627127472",
  hapi: "https://assets.coingecko.com/coins/images/14298/small/R9i2HjAL_400x400.jpg?1615332438",
  "harvest-finance":
    "https://assets.coingecko.com/coins/images/12304/small/Harvest.png?1613016180",
  hashpanda:
    "https://assets.coingecko.com/coins/images/15903/small/logo_-_2021-05-31T060013.983.png?1622412025",
  hedget:
    "https://assets.coingecko.com/coins/images/12453/small/Hedget.png?1599944809",
  hex: "https://assets.coingecko.com/coins/images/10103/small/HEX-logo.png?1575942673",
  "hlth-token":
    "https://assets.coingecko.com/coins/images/18637/small/hlth.png?1639728357",
  "hot-cross":
    "https://assets.coingecko.com/coins/images/15706/small/Hotcross.png?1632197570",
  "huobi-btc":
    "https://assets.coingecko.com/coins/images/12407/small/Unknown-5.png?1599624896",
  husd: "https://assets.coingecko.com/coins/images/9567/small/HUSD.jpg?1568889385",
  hxro: "https://assets.coingecko.com/coins/images/7805/small/Hxro_Profile_Transparent.png?1622443308",
  hydrolink:
    "https://assets.coingecko.com/coins/images/19664/small/200x-logo.png?1635736696",
  "ibnb-2":
    "https://assets.coingecko.com/coins/images/17003/small/output-onlinepngtools-4.png?1626061349",
  "ice-token":
    "https://assets.coingecko.com/coins/images/14586/small/ice.png?1617188825",
  idefiyieldprotocol:
    "https://assets.coingecko.com/coins/images/21976/small/i-DYP-Logo-1.png?1640570294",
  infinitup:
    "https://assets.coingecko.com/coins/images/18890/small/fc_qo2M7_400x400.jpg?1633749805",
  "injective-protocol":
    "https://assets.coingecko.com/coins/images/12882/small/Secondary_Symbol.png?1628233237",
  insure:
    "https://assets.coingecko.com/coins/images/10354/small/logo-grey-circle.png?1614910406",
  "interest-bearing-bitcoin":
    "https://assets.coingecko.com/coins/images/15500/small/ibbtc.png?1621077589",
  "internet-node-token":
    "https://assets.coingecko.com/coins/images/2519/small/int-logo-red-transparent_200x200.png?1617251612",
  investin:
    "https://assets.coingecko.com/coins/images/15588/small/ivn_logo.png?1621267247",
  iotex:
    "https://assets.coingecko.com/coins/images/3334/small/iotex-logo.png?1547037941",
  "iron-bsc":
    "https://assets.coingecko.com/coins/images/16409/small/qBa5_yCL_400x400.jpg?1623927990",
  "iron-stablecoin":
    "https://assets.coingecko.com/coins/images/14588/small/logo_-_2021-03-31T123525.615.png?1617165339",
  "iron-titanium-token":
    "https://assets.coingecko.com/coins/images/16031/small/titan.png?1636080284",
  ispolink:
    "https://assets.coingecko.com/coins/images/15283/small/isolink.PNG?1620352267",
  "jarvis-reward-token":
    "https://assets.coingecko.com/coins/images/10390/small/cfeii0y.png?1578868949",
  joe: "https://assets.coingecko.com/coins/images/17569/small/joe_200x200.png?1628497750",
  "jokermanor-metaverse":
    "https://assets.coingecko.com/coins/images/20556/small/14732.png?1637208904",
  jpyc: "https://assets.coingecko.com/coins/images/17277/small/WoZ8rruL_400x400.png?1627016492",
  kardiachain:
    "https://assets.coingecko.com/coins/images/7942/small/kai.png?1647079540",
  "keep-network":
    "https://assets.coingecko.com/coins/images/3373/small/IuNzUb5b_400x400.jpg?1589526336",
  kin: "https://assets.coingecko.com/coins/images/959/small/kin.png?1586917032",
  kineko:
    "https://assets.coingecko.com/coins/images/15366/small/Kineko.jpeg?1620721965",
  kleekai:
    "https://assets.coingecko.com/coins/images/15548/small/Klee-Kai-Logo.png?1628258448",
  kurobi:
    "https://assets.coingecko.com/coins/images/18612/small/logo_-_2021-09-26T233232.947.png?1632670367",
  lasereyes:
    "https://assets.coingecko.com/coins/images/22597/small/lsr.png?1643524878",
  launchpool:
    "https://assets.coingecko.com/coins/images/14041/small/dGUvV0HQ_400x400.jpg?1613976219",
  "lido-dao":
    "https://assets.coingecko.com/coins/images/13573/small/Lido_DAO.png?1609873644",
  "lido-staked-sol":
    "https://assets.coingecko.com/coins/images/18369/small/logo_-_2021-09-15T100934.765.png?1631671781",
  litecoin:
    "https://assets.coingecko.com/coins/images/2/small/litecoin.png?1547033580",
  livepeer:
    "https://assets.coingecko.com/coins/images/7137/small/logo-circle-green.png?1619593365",
  "lord-arena":
    "https://assets.coingecko.com/coins/images/21141/small/7pylMWZl_400x400.jpg?1638394911",
  "lua-token":
    "https://assets.coingecko.com/coins/images/12627/small/Screenshot_2020-09-28_at_6.24.59_PM.jpg?1601288721",
  "lucky-lion":
    "https://assets.coingecko.com/coins/images/18712/small/lucky-token-200px.png?1633079262",
  lunachow:
    "https://assets.coingecko.com/coins/images/18805/small/J-MwYfhD_400x400.jpg?1633475157",
  "magic-internet-money":
    "https://assets.coingecko.com/coins/images/16786/small/mimlogopng.png?1624979612",
  "mango-markets":
    "https://assets.coingecko.com/coins/images/14773/small/token-mango.png?1628171237",
  "mantra-dao":
    "https://assets.coingecko.com/coins/images/12151/small/OM_3D_whtbg.png?1598332353",
  marinade:
    "https://assets.coingecko.com/coins/images/18867/small/MNDE.png?1643187748",
  math: "https://assets.coingecko.com/coins/images/11335/small/2020-05-19-token-200.png?1589940590",
  "matic-network":
    "https://assets.coingecko.com/coins/images/4713/small/matic-token-icon.png?1624446912",
  maticverse:
    "https://assets.coingecko.com/coins/images/18403/small/A0782-F05-535-C-45-C8-BE4-F-FEBB4-B8-B5933.jpg?1631792934",
  meanfi:
    "https://assets.coingecko.com/coins/images/21557/small/89934951.png?1639466364",
  "merit-circle":
    "https://assets.coingecko.com/coins/images/19304/small/Db4XqML.png?1634972154",
  metaseer:
    "https://assets.coingecko.com/coins/images/17443/small/metas.PNG?1627863142",
  metashooter:
    "https://assets.coingecko.com/coins/images/24985/small/200x200.png?1649681575",
  "metaverse-index":
    "https://assets.coingecko.com/coins/images/14684/small/MVI_logo.png?1617776444",
  million:
    "https://assets.coingecko.com/coins/images/16825/small/logo200x200.png?1625834139",
  mim: "https://assets.coingecko.com/coins/images/19927/small/13988.png?1636323160",
  mimatic:
    "https://assets.coingecko.com/coins/images/15264/small/mimatic-red.png?1620281018",
  minato:
    "https://assets.coingecko.com/coins/images/24622/small/MNTO_200x200.png?1648448664",
  "mirror-protocol":
    "https://assets.coingecko.com/coins/images/13295/small/mirror_logo_transparent.png?1611554658",
  "mirrored-airbnb":
    "https://assets.coingecko.com/coins/images/14022/small/mirror_logo_transparent.png?1613719600",
  "mirrored-amazon":
    "https://assets.coingecko.com/coins/images/13646/small/mirror_logo_transparent.png?1611565645",
  "mirrored-apple":
    "https://assets.coingecko.com/coins/images/13514/small/mirror_logo_transparent.png?1611564758",
  "mirrored-coinbase":
    "https://assets.coingecko.com/coins/images/21089/small/mir.png?1638323675",
  "mirrored-netflix":
    "https://assets.coingecko.com/coins/images/13643/small/mirror_logo_transparent.png?1611565277",
  "mirrored-spdr-s-p-500":
    "https://assets.coingecko.com/coins/images/21088/small/mir.png?1638323591",
  "mirrored-tesla":
    "https://assets.coingecko.com/coins/images/13644/small/mirror_logo_transparent.png?1611565294",
  mixmarvel:
    "https://assets.coingecko.com/coins/images/8222/small/8878caf93b1e3b6cfb3b414bda3b5250.png?1613945432",
  monkeyball:
    "https://assets.coingecko.com/coins/images/20841/small/monkeyball.png?1639023123",
  msol: "https://assets.coingecko.com/coins/images/17752/small/mSOL.png?1644541955",
  "musk-metaverse":
    "https://assets.coingecko.com/coins/images/21822/small/Logo-Symbol-kh-ng-n-n.png?1640075758",
  "my-neighbor-alice":
    "https://assets.coingecko.com/coins/images/14375/small/alice_logo.jpg?1615782968",
  mysterium:
    "https://assets.coingecko.com/coins/images/757/small/mysterium.png?1547034503",
  near: "https://assets.coingecko.com/coins/images/10365/small/near_icon.png?1601359077",
  nexum:
    "https://assets.coingecko.com/coins/images/23472/small/200_-_200_coinmarketcap.png?1644218225",
  "nexus-governance-token":
    "https://assets.coingecko.com/coins/images/19080/small/aK3V5I56_400x400.jpg?1634304970",
  nftlaunch:
    "https://assets.coingecko.com/coins/images/18140/small/nftl.PNG?1630652662",
  "nole-npc":
    "https://assets.coingecko.com/coins/images/19981/small/1EXEFTo6_400x400.jpg?1640251890",
  "nord-finance":
    "https://assets.coingecko.com/coins/images/13630/small/nord.jpg?1610465136",
  nothing:
    "https://assets.coingecko.com/coins/images/16090/small/Gecko-200x200.png?1624544349",
  nuls: "https://assets.coingecko.com/coins/images/1053/small/Nuls.png?1556868153",
  "numbers-protocol":
    "https://assets.coingecko.com/coins/images/20495/small/5J3RAUO2_400x400.jpg?1637131666",
  "odin-protocol":
    "https://assets.coingecko.com/coins/images/14934/small/ODIN_iso_black.png?1619076975",
  "oly-sport":
    "https://assets.coingecko.com/coins/images/19930/small/oly_sport.PNG?1636323685",
  olympus:
    "https://assets.coingecko.com/coins/images/14483/small/token_OHM_%281%29.png?1628311611",
  one: "https://assets.coingecko.com/coins/images/4960/small/Screenshot_39.png?1561103318",
  only1:
    "https://assets.coingecko.com/coins/images/17501/small/like-token.png?1628036165",
  ontology:
    "https://assets.coingecko.com/coins/images/3447/small/ONT.png?1583481820",
  opendao:
    "https://assets.coingecko.com/coins/images/21956/small/fo42wXI6_400x400.jpg?1640373810",
  openocean:
    "https://assets.coingecko.com/coins/images/17014/small/ooe_log.png?1626074195",
  opium:
    "https://assets.coingecko.com/coins/images/13758/small/opium-token-black_%281%29.png?1611767960",
  orbs: "https://assets.coingecko.com/coins/images/4630/small/Orbs.jpg?1547039896",
  orca: "https://assets.coingecko.com/coins/images/17547/small/Orca_Logo.png?1628781615",
  "orion-money":
    "https://assets.coingecko.com/coins/images/18630/small/YtrqPIWc.png?1632710781",
  "orion-protocol":
    "https://assets.coingecko.com/coins/images/11841/small/orion_logo.png?1594943318",
  ovr: "https://assets.coingecko.com/coins/images/13429/small/ovr_logo.png?1608518911",
  "pancake-games":
    "https://assets.coingecko.com/coins/images/20217/small/6oc-L2UC_400x400.png?1636671365",
  "panda-dao":
    "https://assets.coingecko.com/coins/images/14295/small/logo_Panda_Dao.png?1617277854",
  "parasol-finance":
    "https://assets.coingecko.com/coins/images/21551/small/icon.png?1642584584",
  paraswap:
    "https://assets.coingecko.com/coins/images/20403/small/ep7GqM19_400x400.jpg?1636979120",
  "parrot-protocol":
    "https://assets.coingecko.com/coins/images/18443/small/PRT.png?1634698095",
  parsiq:
    "https://assets.coingecko.com/coins/images/11973/small/DsNgK0O.png?1596590280",
  partneroid:
    "https://assets.coingecko.com/coins/images/21381/small/144531867-a8016f41-3b31-4d6f-97a1-372a58d48626.png?1639034184",
  "pax-gold":
    "https://assets.coingecko.com/coins/images/9519/small/paxg.PNG?1568542565",
  "peculium-2":
    "https://assets.coingecko.com/coins/images/21649/small/peculium.jpg?1639640332",
  "perpetual-protocol":
    "https://assets.coingecko.com/coins/images/12381/small/60d18e06844a844ad75901a9_mark_only_03.png?1628674771",
  pillar:
    "https://assets.coingecko.com/coins/images/809/small/v2logo-1.png?1624906282",
  pixelverse:
    "https://assets.coingecko.com/coins/images/19934/small/pixelverse.PNG?1636325521",
  "planet-finance":
    "https://assets.coingecko.com/coins/images/15710/small/aqua-icon.png?1621583770",
  "plant-vs-undead-token":
    "https://assets.coingecko.com/coins/images/17461/small/token-200x200.png?1627883446",
  playnity:
    "https://assets.coingecko.com/coins/images/21479/small/ply.png?1639651574",
  poken:
    "https://assets.coingecko.com/coins/images/21574/small/G10VNBAR_400x400.jpg?1639490463",
  polkadot:
    "https://assets.coingecko.com/coins/images/12171/small/polkadot.png?1639712644",
  "polychain-monsters":
    "https://assets.coingecko.com/coins/images/14604/small/polkamon.png?1617238350",
  "polygon-ecosystem-index":
    "https://assets.coingecko.com/coins/images/19270/small/amun-peco.png?1634868167",
  pontoon:
    "https://assets.coingecko.com/coins/images/19575/small/pontoon.PNG?1635467899",
  "poolz-finance":
    "https://assets.coingecko.com/coins/images/13679/small/poolz_logo.png?1610806091",
  "pstake-finance":
    "https://assets.coingecko.com/coins/images/23931/small/PSTAKE_Dark.png?1645709930",
  "pstake-staked-atom":
    "https://assets.coingecko.com/coins/images/18484/small/stkATOM_-_128px.png?1634978065",
  psyoptions:
    "https://assets.coingecko.com/coins/images/22784/small/download.png?1642580392",
  "ptokens-btc":
    "https://assets.coingecko.com/coins/images/10805/small/J51iIea.png?1583891599",
  "pylon-protocol":
    "https://assets.coingecko.com/coins/images/16859/small/pylon_logo.png?1625466331",
  "qi-dao":
    "https://assets.coingecko.com/coins/images/15329/small/qi.png?1620540969",
  quick:
    "https://assets.coingecko.com/coins/images/13970/small/1_pOU6pBMEmiL-ZJVb0CYRjQ.png?1613386659",
  quiztok:
    "https://assets.coingecko.com/coins/images/8208/small/QTCON.png?1587543372",
  "radio-caca":
    "https://assets.coingecko.com/coins/images/17841/small/ez44_BSs_400x400.jpg?1629464170",
  rai: "https://assets.coingecko.com/coins/images/14004/small/RAI-logo-coin.png?1613592334",
  "rally-2":
    "https://assets.coingecko.com/coins/images/12843/small/image.png?1611212077",
  "rally-solana":
    "https://assets.coingecko.com/coins/images/23239/small/srly.png?1643531979",
  ramp: "https://assets.coingecko.com/coins/images/12837/small/RAMP-Logo-v2-1000pxsq.png?1617952606",
  raydium:
    "https://assets.coingecko.com/coins/images/13928/small/PSigc4ie_400x400.jpg?1612875614",
  recharge:
    "https://assets.coingecko.com/coins/images/18120/small/thecharge.PNG?1630559768",
  "redfox-labs-2":
    "https://assets.coingecko.com/coins/images/12956/small/rfox.png?1642926902",
  "redlight-node-district":
    "https://assets.coingecko.com/coins/images/23338/small/rnd-coin.png?1643883118",
  renbtc:
    "https://assets.coingecko.com/coins/images/11370/small/Bitcoin.jpg?1628072791",
  "render-token":
    "https://assets.coingecko.com/coins/images/11636/small/rndr.png?1638840934",
  "reserve-rights-token":
    "https://assets.coingecko.com/coins/images/8365/small/rsr.png?1637983320",
  ridotto:
    "https://assets.coingecko.com/coins/images/18671/small/200x200_%2832%29.png?1632875527",
  "rizespor-token":
    "https://assets.coingecko.com/coins/images/24027/small/mqQwSHB__400x400.jpg?1646113446",
  "rope-token":
    "https://assets.coingecko.com/coins/images/14661/small/rope-v6.png?1619606776",
  rougecoin:
    "https://assets.coingecko.com/coins/images/14621/small/rougecoin.png?1617265377",
  rune: "https://assets.coingecko.com/coins/images/15606/small/rune-200x200.png?1621315121",
  saber:
    "https://assets.coingecko.com/coins/images/17162/small/oYs_YFz8_400x400.jpg?1626678457",
  "safe-coin":
    "https://assets.coingecko.com/coins/images/4938/small/safe-coin-logo.png?1547040363",
  safemoon:
    "https://assets.coingecko.com/coins/images/14362/small/174x174-white.png?1617174846",
  "safuyield-protocol":
    "https://assets.coingecko.com/coins/images/17021/small/safuyield.png?1626098281",
  sail: "https://assets.coingecko.com/coins/images/16657/small/SAIL.png?1624608515",
  "saitama-inu":
    "https://assets.coingecko.com/coins/images/16353/small/Capture.PNG?1632126703",
  samoyedcoin:
    "https://assets.coingecko.com/coins/images/15051/small/IXeEj5e.png?1619560738",
  sarcophagus:
    "https://assets.coingecko.com/coins/images/15091/small/E2S2-CcUcAAyNxD.jpeg?1622519884",
  secret:
    "https://assets.coingecko.com/coins/images/11871/small/Secret.png?1595520186",
  serum:
    "https://assets.coingecko.com/coins/images/11970/small/serum-logo.png?1597121577",
  "shiba-inu":
    "https://assets.coingecko.com/coins/images/11939/small/shiba.png?1622619446",
  "shield-finance":
    "https://assets.coingecko.com/coins/images/15813/small/sign_dark_200x200.png?1646641417",
  "shill-token":
    "https://assets.coingecko.com/coins/images/18176/small/SHILL_Logo.png?1630896205",
  shirtum:
    "https://assets.coingecko.com/coins/images/16955/small/4fWlpC0.png?1625794164",
  sifchain:
    "https://assets.coingecko.com/coins/images/14044/small/EROWAN.png?1614656300",
  "smooth-love-potion":
    "https://assets.coingecko.com/coins/images/10366/small/SLP.png?1578640057",
  "socean-staked-sol":
    "https://assets.coingecko.com/coins/images/18468/small/biOTzfxE_400x400.png?1633662119",
  solana:
    "https://assets.coingecko.com/coins/images/4128/small/solana.png?1640133422",
  "solanasail-governance-token":
    "https://assets.coingecko.com/coins/images/17658/small/logo_GSAIL.png?1628758657",
  solanium:
    "https://assets.coingecko.com/coins/images/15816/small/token-icon.png?1621981387",
  "solape-token":
    "https://assets.coingecko.com/coins/images/16930/small/128px-coin.png?1625753550",
  "solareum-wallet":
    "https://assets.coingecko.com/coins/images/20958/small/xsb-200.png?1638141904",
  "solchicks-token":
    "https://assets.coingecko.com/coins/images/20978/small/chicks.png?1638162821",
  solcial:
    "https://assets.coingecko.com/coins/images/24583/small/1_N9szP0_400x400.jpg?1648217020",
  soldoge:
    "https://assets.coingecko.com/coins/images/19746/small/2L4aX1r.png?1635822424",
  "solpad-finance":
    "https://assets.coingecko.com/coins/images/16368/small/solpad.PNG?1623820231",
  solrazr:
    "https://assets.coingecko.com/coins/images/18390/small/Sol-Razr-Logo-TICKER.png?1631759669",
  "spell-token":
    "https://assets.coingecko.com/coins/images/15861/small/abracadabra-3.png?1622544862",
  "spongebob-square":
    "https://assets.coingecko.com/coins/images/22772/small/Spnge.png?1642576286",
  sportium:
    "https://assets.coingecko.com/coins/images/20981/small/sportium_logo_symbolmark_skyblue.png?1638163975",
  "squirrel-finance":
    "https://assets.coingecko.com/coins/images/12415/small/transparent_logo200.png?1599690422",
  stader:
    "https://assets.coingecko.com/coins/images/20658/small/sd.png?1642927667",
  "staked-ether":
    "https://assets.coingecko.com/coins/images/13442/small/steth_logo.png?1608607546",
  "star-atlas":
    "https://assets.coingecko.com/coins/images/17659/small/Icon_Reverse.png?1628759092",
  "stargate-finance":
    "https://assets.coingecko.com/coins/images/24413/small/STG_LOGO.png?1647654518",
  starlaunch:
    "https://assets.coingecko.com/coins/images/20109/small/OP3eksDQ_400x400.png?1636513478",
  starterra:
    "https://assets.coingecko.com/coins/images/17715/small/starterra-logo.png?1629084125",
  "step-finance":
    "https://assets.coingecko.com/coins/images/14988/small/step.png?1619274762",
  stepn:
    "https://assets.coingecko.com/coins/images/23597/small/gmt.png?1644658792",
  streamr:
    "https://assets.coingecko.com/coins/images/17869/small/DATA_new_symbol_3x.png?1629692324",
  "sunny-aggregator":
    "https://assets.coingecko.com/coins/images/18039/small/90dbe787-8e5f-473c-b923-fe138a7a30ea.png?1630314924",
  sushi:
    "https://assets.coingecko.com/coins/images/12271/small/512x512_Logo_no_chop.png?1606986688",
  "swag-finance":
    "https://assets.coingecko.com/coins/images/12805/small/photo_2020-10-14_23.17.02.jpeg?1602688642",
  swipe:
    "https://assets.coingecko.com/coins/images/9368/small/swipe.png?1566792311",
  synchrony:
    "https://assets.coingecko.com/coins/images/19308/small/SYNCHRONY-LOGO.png?1634973091",
  "synthetify-token":
    "https://assets.coingecko.com/coins/images/14835/small/synthetify_token.png?1618611507",
  sypool:
    "https://assets.coingecko.com/coins/images/18518/small/sypool.PNG?1632268218",
  tenset:
    "https://assets.coingecko.com/coins/images/14629/small/10set.png?1617353812",
  "terra-luna":
    "https://assets.coingecko.com/coins/images/8284/small/luna1557227471663.png?1567147072",
  "terra-virtua-kolect":
    "https://assets.coingecko.com/coins/images/13330/small/CoinGLogo.png?1607507042",
  terrausd:
    "https://assets.coingecko.com/coins/images/12681/small/UST.png?1601612407",
  tether:
    "https://assets.coingecko.com/coins/images/325/small/Tether-logo.png?1598003707",
  "the-4th-pillar":
    "https://assets.coingecko.com/coins/images/3434/small/four-ticker-2021-256x256.png?1617702287",
  "the-graph":
    "https://assets.coingecko.com/coins/images/13397/small/Graph_Token.png?1608145566",
  "the-sandbox":
    "https://assets.coingecko.com/coins/images/12129/small/sandbox_logo.jpg?1597397942",
  throne:
    "https://assets.coingecko.com/coins/images/16965/small/aXhD3i_g_400x400.jpg?1625804145",
  "tiki-token":
    "https://assets.coingecko.com/coins/images/16427/small/60cbd8fd912298ca60e1fd7e_logo_TIKI_200_square.png?1623995319",
  "token-pocket":
    "https://assets.coingecko.com/coins/images/7603/small/_E6sbg1g_400x400.jpg?1548828066",
  tomoe:
    "https://assets.coingecko.com/coins/images/12646/small/tomoe_logo.png?1601377449",
  torg: "https://assets.coingecko.com/coins/images/17596/small/TORG_Logo_200x200.png?1628586056",
  "true-usd":
    "https://assets.coingecko.com/coins/images/3449/small/tusd.png?1618395665",
  "trust-wallet-token":
    "https://assets.coingecko.com/coins/images/11085/small/Trust.png?1588062702",
  tryhards:
    "https://assets.coingecko.com/coins/images/18624/small/TryHards_Tokenticker.png?1650437198",
  tudabirds:
    "https://assets.coingecko.com/coins/images/22839/small/_TOvRxfx_400x400.jpg?1642745695",
  "twirl-governance-token":
    "https://assets.coingecko.com/coins/images/16725/small/Yn1ebvX.png?1624850650",
  "ufo-gaming":
    "https://assets.coingecko.com/coins/images/16801/small/ufo.png?1644048038",
  uniswap:
    "https://assets.coingecko.com/coins/images/12504/small/uniswap-uni.png?1600306604",
  upbots:
    "https://assets.coingecko.com/coins/images/12476/small/UBXT.png?1600132967",
  "usd-coin":
    "https://assets.coingecko.com/coins/images/6319/small/USD_Coin_icon.png?1547042389",
  usdk: "https://assets.coingecko.com/coins/images/8824/small/usdk.png?1563418517",
  "vega-protocol":
    "https://assets.coingecko.com/coins/images/15870/small/vega.PNG?1622178218",
  "vent-finance":
    "https://assets.coingecko.com/coins/images/17925/small/Artboard_29.png?1629804982",
  victorum:
    "https://assets.coingecko.com/coins/images/17391/small/Victorum-logo200X200.png?1627525058",
  vlaunch:
    "https://assets.coingecko.com/coins/images/20838/small/vlaunch_22.png?1637738535",
  "vodka-token":
    "https://assets.coingecko.com/coins/images/20848/small/Vodka-Token-LOGO.png?1637760753",
  "waggle-network":
    "https://assets.coingecko.com/coins/images/18696/small/waggle.PNG?1633750177",
  "wall-street-bets-dapp":
    "https://assets.coingecko.com/coins/images/15093/small/Pe1mrDu.png?1629882480",
  wasder:
    "https://assets.coingecko.com/coins/images/15374/small/wasderlogo200x200.png?1620691729",
  waves:
    "https://assets.coingecko.com/coins/images/425/small/waves.png?1548386117",
  wbnb: "https://assets.coingecko.com/coins/images/12591/small/binance-coin-logo.png?1600947313",
  weth: "https://assets.coingecko.com/coins/images/2518/small/weth.png?1628852295",
  weyu: "https://assets.coingecko.com/coins/images/18112/small/weyu.PNG?1630542552",
  wizardia:
    "https://assets.coingecko.com/coins/images/24434/small/Icon_%281%29.jpg?1648177628",
  wmatic:
    "https://assets.coingecko.com/coins/images/14073/small/matic.png?1628852392",
  wolfsafepoorpeople:
    "https://assets.coingecko.com/coins/images/17090/small/wspplogo.png?1626187594",
  "woo-network":
    "https://assets.coingecko.com/coins/images/12921/small/w2UiemF__400x400.jpg?1603670367",
  "woof-token":
    "https://assets.coingecko.com/coins/images/18319/small/woof-logo-svg-true-solana-radient-blackinside.png?1637655115",
  wowswap:
    "https://assets.coingecko.com/coins/images/14101/small/Group-423.png?1614317472",
  wraith:
    "https://assets.coingecko.com/coins/images/18099/small/LOGOTRANS-1.png?1630475109",
  "wrapped-avax":
    "https://assets.coingecko.com/coins/images/15075/small/wrapped-avax.png?1629873618",
  "wrapped-bitcoin":
    "https://assets.coingecko.com/coins/images/7598/small/wrapped_bitcoin_wbtc.png?1548822744",
  "wrapped-busd":
    "https://assets.coingecko.com/coins/images/19498/small/wbusd.png?1635305456",
  "wrapped-busd-allbridge-from-bsc":
    "https://assets.coingecko.com/coins/images/23061/small/logo_-_2022-01-26T091043.556.png?1643159457",
  "wrapped-ecomi":
    "https://assets.coingecko.com/coins/images/14675/small/ecomi.jpg?1617689100",
  "wrapped-fantom":
    "https://assets.coingecko.com/coins/images/16036/small/Fantom.png?1622679930",
  "wrapped-memory":
    "https://assets.coingecko.com/coins/images/22392/small/wmemo.png?1641792100",
  "wrapped-solana":
    "https://assets.coingecko.com/coins/images/21629/small/solana.jpg?1639626543",
  "wrapped-steth":
    "https://assets.coingecko.com/coins/images/18834/small/wstETH.png?1633565443",
  "wrapped-terra":
    "https://assets.coingecko.com/coins/images/13628/small/wluna.png?1610448334",
  "wrapped-usdt":
    "https://assets.coingecko.com/coins/images/19507/small/wusdt.png?1635315186",
  "wrapped-ust":
    "https://assets.coingecko.com/coins/images/15462/small/ust.png?1620910058",
  "wrapped-weth": "missing_small.png",
  "xcad-network":
    "https://assets.coingecko.com/coins/images/15857/small/xcad.PNG?1622164789",
  xdefi:
    "https://assets.coingecko.com/coins/images/19524/small/xdefi.png?1637917251",
  xhashtag:
    "https://assets.coingecko.com/coins/images/20912/small/xtag.png?1637922382",
  xsgd: "https://assets.coingecko.com/coins/images/12832/small/StraitsX_Singapore_Dollar_%28XSGD%29_Token_Logo.png?1633936813",
  xsigma:
    "https://assets.coingecko.com/coins/images/14090/small/logo_128.png?1619775781",
  "yearn-finance":
    "https://assets.coingecko.com/coins/images/11849/small/yfi-192x192.png?1598325330",
  "yield-optimization-platform":
    "https://assets.coingecko.com/coins/images/13678/small/J7zykPx.jpg?1610802162",
  "zam-io":
    "https://assets.coingecko.com/coins/images/19522/small/zam.png?1635324134",
  zap: "https://assets.coingecko.com/coins/images/2180/small/zap.png?1547036476",
  zoints:
    "https://assets.coingecko.com/coins/images/20376/small/logo_-_2021-11-15T121641.242.png?1636949811",
  ztcoin:
    "https://assets.coingecko.com/coins/images/6566/small/ztcoin.jpg?1547042777",
};
